/**
 * =============================================================================
 * theme.js
 * =============================================================================
 * Entry point for all theme Javascript.
 * 
 * Before launching a site, consider what imports you actually need - i.e. which
 * parts of Bootstrap, which vendor JS imports, which Bootstrap plugins, etc.
 * =============================================================================
 */

// Imports from node_modules, installed via 'yarn add ...'
import * as bootstrap from 'bootstrap'; // (~97Kb)
import Swiper from 'swiper/swiper-bundle'; // (~144Kb)
import 'waypoints/lib/noframework.waypoints.min.js'; // (~10Kb)
import Cookies from 'js-cookie'; // (~2Kb)
import AOS from 'aos'; // Animate on Scroll (~14Kb)
import TomSelect from 'tom-select'; // TomSelect (~52Kb)

// Export for others scripts to use by attaching to the window
window.bootstrap = bootstrap;
window.Swiper = Swiper;
window.Cookies = Cookies;
window.TomSelect = TomSelect;

// Initialisation
AOS.init({
  once: true
});

// Imports from this folder - MP-specific
import MP from './mp';

import Blog from './blog';
import Cart from './cart';
import Collection from './collection';
import CookieBar from './cookie-bar';
import Facets from './facets';
import Localization from './localization';
import Nav from './nav';
import ProductFormManager from './product-form-manager';
import ProductModels from './product-models';
import ProductTile from "./product-tile";
import Recommendations from './recommendations';
import ReviewModals from './review-modals';


customElements.define('product-tile', ProductTile);

// Export for others scripts to use by attaching to the window
MP.Extensions.Blog = Blog;
MP.Extensions.Cart = Cart;
MP.Extensions.Collection = Collection;
MP.Extensions.CookieBar = CookieBar;
MP.Extensions.Facets = Facets;
MP.Extensions.Localization = Localization;
MP.Extensions.Nav = Nav;
MP.Extensions.ProductFormManager = ProductFormManager;
MP.Extensions.ProductModels = ProductModels;
MP.Extensions.Recommendations = Recommendations;
MP.Extensions.ReviewModals = ReviewModals;


// Global functions
window.debounce = function(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// Kickoff!
window.MP = Object.assign(MP, window.MP);
MP.init();